<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import router from '@/router'
import { RouteName } from '@/routes'
import { T } from '@tolgee/vue'
import BaseLinkButton from '@/components/base/BaseLinkButton.vue'
import { usePlayerProfit } from '@/composables/game/player'

defineProps<{
  show: boolean
}>()
defineEmits(['hide'])

const {
  hasExtraOfflineProfit,
  formattedExtraOfflineProfit,
} = usePlayerProfit()
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <img
        class="w-[80px] h-[80px] object-cover"
        src="@/assets/images/gifs/money-bag.gif"
      >
      <div class="mt-6 text-2xl font-bold -tracking-[0.48px] text-light-white text-center">
        <T
          key-name="boost_profit_modal.title"
          default-value="Boost your profits"
        />
      </div>
      <div class="mt-1 text-white/60 text-lg font-semibold text-center">
        <T
          key-name="boost_profit_modal.description1"
          default-value="Your trading per hour automatically grows your profits!"
        />
        <br>
        <T
          key-name="boost_profit_modal.description2"
          default-value="Go to the"
        />
        {{ " " }}
        <BaseLinkButton
          text-class="text-lg pt-0 pb-0"
          @click="$emit('hide'); router.push({name: RouteName.MINE})"
        >
          <T
            key-name="boost_profit_modal.improve_page"
            default-value="Improve page"
          />
        </BaseLinkButton>
        {{ " " }}
        <T
          key-name="boost_profit_modal.description3"
          default-value="to upgrade your cards and boost your earnings."
        />
      </div>
      <div class="mt-6 text-sm font-semibold -tracking-[0.28px] text-center">
        <T
          v-if="hasExtraOfflineProfit"
          key-name="boost_profit_modal.extended_offline_profit"
          default-value="Your offline profits have been extended"
        />
        <T
          v-else
          key-name="boost_profit_modal.normal_offline_profit"
          default-value="Earn even when offline, up to 3 hours"
        />
      </div>
      <div
        v-if="hasExtraOfflineProfit"
        class="mt-3 rounded-full py-[14px] px-8 bg-dark-most-bottom-layer text-[24px] leading-5 -tracking-[0.48px] font-medium"
      >
        {{ formattedExtraOfflineProfit }}
      </div>
      <BaseButton
        class="mt-8 w-full"
        @click="$emit('hide')"
      >
        <T
          key-name="boost_profit_modal.got_it"
          default-value="Got it"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>